import './Alignment.css';
import './DataTableV2Rows.css';
import '../DataTableV2.css';
import '../features/ColumnOrder/ColumnOrder.css';
import '../features/Thresholds/Thresholds.css';
import './DataTableV2Header.css';
import '../features/Sorting/Sorting.css';
import './DataTableV2DefaultCell.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var dataTableV2DefaultCellCSS = _7a468({defaultClassName:'_19i00fl0-2-0-1',variantClassNames:{lineWrap:{true:'_19i00fl1-2-0-1',false:'_19i00fl2-2-0-1'},rowDensity:{'default':'_19i00fl3-2-0-1',condensed:'_19i00fl4-2-0-1',comfortable:'_19i00fl5-2-0-1'}},defaultVariants:{rowDensity:'default'},compoundVariants:[]});